if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      if (this.modalContent) this.modalContent.innerHTML = '';

      // The opener can be the card's hover ATC button, which lives translated
      // off-screen (translateY(100%)) inside an overflow:hidden image wrapper.
      // ModalDialog.hide()'s removeTrapFocus(opener) calls .focus() WITHOUT
      // preventScroll, which scrolls that wrapper to reveal the button — lifting
      // the image and leaving the card stuck looking "hovered". So we suppress
      // the default focus and restore it ourselves with preventScroll.
      const opener = this.openedBy;
      this.openedBy = null;
      super.hide();
      if (!preventFocus && opener && typeof opener.focus === 'function') {
        opener.focus({ preventScroll: true });
      }
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      const spinner = opener.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          // The quick-add section root carries `.ih-quick-add` (and `.section-main-product`
          // so the reused selling-plan / product-form / variant components resolve via closest()).
          this.productElement = responseHTML.querySelector('.ih-quick-add');
          if (!this.productElement) return;

          this.preventVariantURLSwitching();
          this.setInnerHTML(this.modalContent, this.productElement.outerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Re-inject script tags so they execute (innerHTML-inserted scripts are inert by default).
      element.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.productElement.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }
  });
}
